import { useFonts } from "expo-font";
import { Text, View, StyleSheet, ScrollView } from "react-native";

import { windowHeight, windowWidth } from "../constants";
import ImgSlider from "./ImgSlider";
import Privacy from "./Privacy";

const Landing = () => {
  const [fontsLoaded] = useFonts({
    OpenSans: require("../assets/fonts/OpenSans-SemiBold.ttf"),
    Montserrart: require("../assets/fonts/Montserrat-Regular.ttf"),
  });
  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          flex: 1,
          alignSelf: "center",
          flexGrow: 0,
          marginVertical: 20,
        }}
      >
        <Text style={styles.headingText}>Downify</Text>
      </View>

      <ScrollView
        style={{
          flex: 1,
          alignSelf: "center",
          maxWidth: windowWidth * 0.9,
          marginTop: 50,
        }}
        contentContainerStyle={{ padding: 10 }}
        showsHorizontalScrollIndicator={true}
      >
        <Privacy />
      </ScrollView>
      {/* <View
        style={{
          flex: 3,
          backgroundColor: "red",
          flexDirection: "column",
          justifyContent: "flex-start",
          flexShrink: 1,
          flexWrap: "wrap",
        }}
      >
        <View
          style={{
            flex: 3,

            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Text
            style={{
              fontSize: 20,
              fontWeight: "bold	",
              fontFamily: "Montserrart",
            }}
          >
            Features
          </Text>
        </View>
        <View
          style={{
            flex: 2,
            backgroundColor: "blue",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <ImgSlider />
        </View>
      </View> */}
    </View>
  );
};

export default Landing;

const styles = StyleSheet.create({
  headingText: {
    fontSize: 50,
    fontWeight: "bold",
    fontFamily: "RobotoMedium",
    margin: "auto",
  },
});
